function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.2 2.7499C12.577 2.7499 12.8825 2.8799 13.123 3.1334C13.37 3.3999 13.5 3.6924 13.5 4.0499V11.1999C13.5 11.5574 13.37 11.8499 13.123 12.1164C12.8825 12.3699 12.577 12.4999 12.2 12.4999H1.8C1.423 12.4999 1.1175 12.3699 0.877 12.1164C0.63 11.8499 0.5 11.5574 0.5 11.1999V4.0499C0.5 3.6924 0.63 3.3999 0.877 3.1334C1.1175 2.8799 1.423 2.7499 1.8 2.7499H4.4V1.4499C4.4 1.0729 4.53 0.767402 4.777 0.526902C5.0175 0.279902 5.323 0.149902 5.7 0.149902H8.3C8.677 0.149902 8.9825 0.279902 9.223 0.526902C9.47 0.767402 9.6 1.0729 9.6 1.4499V2.7499H12.2ZM1.8 4.0499V11.1999H12.2V4.0499H1.8ZM8.3 2.7499V1.4499H5.7V2.7499H8.3Z",
  fill: "currentColor"
});

var SvgBriefcase = function SvgBriefcase(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBriefcase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/briefcase.4cc404fb.svg";
export { ForwardRef as ReactComponent };